import { Loader2, Upload } from "lucide-react";
import { Modal } from "../../../../components/Modal";

export interface ExportDialogProps {
  open: boolean;
  onClose: () => void;
  exportingDoc: boolean;
  handleExport: (format: "json" | "xml" | "yaml") => void;
}

export function ExportDialog({
  open,
  onClose,
  exportingDoc,
  handleExport,
}: ExportDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Export"
      description="Choose a file format to export this System Security Plan."
      size="sm"
    >
      <div className="grid grid-cols-3 gap-3">
        {(["json", "xml", "yaml"] as const).map((fmt) => (
          <button
            key={fmt}
            onClick={() => handleExport(fmt)}
            disabled={exportingDoc}
            className="flex flex-col items-center gap-2 p-4 rounded-lg border border-border hover:border-indigo-400 dark:hover:border-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-500/10 transition-colors group disabled:opacity-40"
          >
            {exportingDoc ? (
              <Loader2 className="size-6 animate-spin text-muted-foreground" />
            ) : (
              <Upload className="size-6 text-muted-foreground group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors" />
            )}
            <span className="text-sm font-semibold group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors">
              {fmt.toUpperCase()}
            </span>
          </button>
        ))}
      </div>
    </Modal>
  );
}
